import ProxyBase from '../../ProxyBase';
import ServiceProxyConfig from '../../../../configs/ServiceProxyConfig';

class SummaryProxy extends ProxyBase {
  getWatchListSummary(data, source) {
    return this.get('GetWatchListSummary', data, source);
  }

  getWatchListDerivative(data, source) {
    return this.get('getDerivatives', data, source);
  }

  getBonds(data, source) {
    return this.get('GetBonds', data, source);
  }

  getWatchListPutThrough(data, source) {
    return this.get('GetPutThrough', data, source);
  }

  getTwoDaysSeries(data, source) {
    return this.get('GetTwoDaysSeries', data, source);
  }

  getTickerSummary(data, source) {
    return this.get('GetTickerSummary', data, source);
  }
}

const summaryProxy = new SummaryProxy(
  ServiceProxyConfig.Market.WatchList.ServiceUrl,
);
export default summaryProxy;
